/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const t = "treelist.filterClearButton", e = "treelist.filterEqOperator", r = "treelist.filterNotEqOperator", l = "treelist.filterIsNullOperator", o = "treelist.filterIsNotNullOperator", s = "treelist.filterIsEmptyOperator", i = "treelist.filterIsNotEmptyOperator", a = "treelist.filterStartsWithOperator", f = "treelist.filterContainsOperator", n = "treelist.filterNotContainsOperator", p = "treelist.filterEndsWithOperator", O = "treelist.filterGteOperator", c = "treelist.filterGtOperator", I = "treelist.filterLteOperator", u = "treelist.filterLtOperator", E = "treelist.filterIsTrue", q = "treelist.filterIsFalse", N = "treelist.filterBooleanAll", h = "treelist.filterAfterOrEqualOperator", B = "treelist.filterAfterOperator", C = "treelist.filterBeforeOperator", m = "treelist.filterBeforeOrEqualOperator", A = "treelist.noRecords", d = {
  [t]: "Clear",
  [e]: "Is equal to",
  [r]: "Is not equal to",
  [l]: "Is null",
  [o]: "Is not null",
  [s]: "Is empty",
  [i]: "Is not empty",
  [a]: "Starts with",
  [f]: "Contains",
  [n]: "Does not contain",
  [p]: "Ends with",
  [O]: "Is greater than or equal to",
  [c]: "Is greater than",
  [I]: "Is less than or equal to",
  [u]: "Is less than",
  [E]: "Is true",
  [q]: "Is false",
  [N]: "(All)",
  [h]: "Is after or equal to",
  [B]: "Is after",
  [C]: "Is before",
  [m]: "Is before or equal to",
  [A]: "No records available"
};
export {
  B as filterAfterOperator,
  h as filterAfterOrEqualOperator,
  C as filterBeforeOperator,
  m as filterBeforeOrEqualOperator,
  N as filterBooleanAll,
  t as filterClearButton,
  f as filterContainsOperator,
  p as filterEndsWithOperator,
  e as filterEqOperator,
  c as filterGtOperator,
  O as filterGteOperator,
  s as filterIsEmptyOperator,
  q as filterIsFalse,
  i as filterIsNotEmptyOperator,
  o as filterIsNotNullOperator,
  l as filterIsNullOperator,
  E as filterIsTrue,
  u as filterLtOperator,
  I as filterLteOperator,
  n as filterNotContainsOperator,
  r as filterNotEqOperator,
  a as filterStartsWithOperator,
  d as messages,
  A as noRecords
};
